import { render, staticRenderFns } from "./public-layout.vue?vue&type=template&id=457d5a2e&"
import script from "./public-layout.vue?vue&type=script&lang=js&"
export * from "./public-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports